import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import about from '@/components/about'
import mnqf from '@/components/mnqf'
import downloads from '@/components/downloads'
import news from '@/components/news'
import gallery from '@/components/gallery'
import institutes from '@/components/institutes'
import local from '@/components/SharedComponents/Local'
import overseas from '@/components/SharedComponents/Overseas'
import institute from '@/components/institute'
import course from '@/components/course'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: index
        },
        {
            path: '/about',
            name: 'about',
            component: about
        },
        {
            path: '/mnqf',
            name: 'mnqf',
            component: mnqf
        },
        {
            path: '/downloads',
            name: 'downloads',
            component: downloads
        },
        {
            path: '/news',
            name: 'news',
            component: news
        },
        {
            path: '/gallery',
            name: 'gallery',
            component: gallery
        },
        {
            path: '/institutes',
            name: 'institutes',
            component: institutes,
            redirect: '/institutes/local',
            children: [
                {
                    path: 'local',
                    name: 'local',
                    component: local
                },
                {
                    path: 'overseas',
                    name: 'International',
                    component: overseas
                },
                {
                    path: ':institute_id',
                    name: 'institute',
                    component: institute,
                }
            ]
        },
        {
            path: '/institutes/:institute_id/courses/:course_id',
            name: 'course',
            component: course
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js